import { z } from "zod";

import {
  DataExportV2DestinationType,
  DataExportV2DestinationFormat,
} from "@north-beam/nb-client-side/nb-api-graphql-generated";

export const gcsDestinationSchema = z.object({
  type: z.literal(DataExportV2DestinationType.GCS),
  bucketName: z
    .string()
    .min(3, "Bucket name must be at least 3 characters long"),
  exportFormat: z.nativeEnum(DataExportV2DestinationFormat),
  fileName: z.union([z.string(), z.null()]),
  isBucketValid: z.coerce.boolean().refine((bool) => bool === true, {
    message: "Please provide the correct permissions to your bucket",
  }),
});
